import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export const DEFAULT_GAME = { enabled: true, target_score: 50000, duration_sec: 120, discount_percent: 20, offer_validity_days: 30, max_pauses: 2, max_pause_total_sec: 45 };

export function SiteProvider({ children }) {
  const [config, setConfig] = useState({ game: DEFAULT_GAME, contacts: {} });
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [game, setGame] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const [c, p] = await Promise.all([api.get("/config"), api.get("/projects")]);
      setConfig(c.data);
      setProjects(p.data);
    } catch {
      /* keep defaults, sections render gracefully */
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  useEffect(() => {
    const load = () => !document.hidden && api.get("/projects").then((p) => setProjects(p.data)).catch(() => {});
    const id = setInterval(load, 30000);
    document.addEventListener("visibilitychange", load);
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", load); };
  }, []);

  const openGame = useCallback((mode = "play") => setGame({ mode, key: Date.now() }), []);
  const closeGame = useCallback(() => { setGame(null); refresh(); }, [refresh]);

  return (
    <SiteCtx.Provider value={{ config, projects, loading, game, openGame, closeGame }}>
      {children}
    </SiteCtx.Provider>
  );
}

export const useSite = () => useContext(SiteCtx);
